import { useState, useRef } from 'react'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import { Button, Popover, MenuItem, MenuList } from '@mui/material'
import { arrayOf, object, node } from 'prop-types'
import { colors } from '@global/constants'

export const CvsImmediateActionDropdownButton = ({
  title,
  options,
  icon = null,
  style,
  disabled,
  name = 'immediate-action-dropdown-button',
}) => {
  const [open, setOpen] = useState(false)
  const anchorRef = useRef(null)
  return (
    <>
      <Button
        name={name}
        style={{ color: colors.white, padding: '5px 0px', ...style }}
        variant="contained"
        ref={anchorRef}
        startIcon={icon}
        onClick={() => setOpen(prevOpen => !prevOpen)}
        endIcon={open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        disabled={disabled}
      >
        {title}
      </Button>
      <Popover
        open={open}
        onClose={() => setOpen(false)}
        anchorEl={anchorRef.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuList id="split-button-menu">
          {options.map(option => (
            <MenuItem
              disabled={option.disabled === true}
              key={option.title}
              onClick={() => {
                option.action()
                setOpen(false)
              }}
            >
              {option.title}
            </MenuItem>
          ))}
        </MenuList>
      </Popover>
    </>
  )
}
CvsImmediateActionDropdownButton.propTypes = {
  options: arrayOf(object).isRequired,
  icon: node,
}
